import { ConfirmationModal, Text } from '@shared/components';

export interface RecurringExamEventCreationAllFailedModalProps {
  open: boolean;
  failedCount: number;
  onRetry: () => void;
  onClose: () => void;
}

export default function RecurringExamEventCreationAllFailedModal(
  props: Readonly<RecurringExamEventCreationAllFailedModalProps>,
) {
  const { open, failedCount, onRetry, onClose } = props;

  return (
    <ConfirmationModal
      open={open}
      maxWidth='xs'
      title='ไม่สามารถสร้างรอบสอบได้'
      content={
        <Text>
          สร้างรอบสอบไม่สำเร็จทั้งหมด {failedCount} รอบ กรุณาลองสร้างอีกครั้ง หรือปิดหน้าต่าง
        </Text>
      }
      acceptText={`ลองสร้างอีกครั้ง (${failedCount} รอบ)`}
      discardText='ปิดหน้าต่าง'
      onAccept={onRetry}
      onDiscard={onClose}
      onClose={onClose}
    />
  );
}
